/* ==========================================================================
   TC — Comportamientos de la landing de Colágeno 5 Tipos (TELORA MX)
   Un solo script para todas las secciones. Sin dependencias.

   Cubre: reveal on scroll con stagger · barra de anuncios · galería
   arrastrable + miniaturas + dots · selector de packs · toggle de
   suscripción · acordeones · comparador antes/después · carrusel de
   reseñas · barra sticky · contadores de las cifras.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__tcInit) return;
  window.__tcInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Devuelve los elementos que todavía no se han inicializado PARA ESE selector.
     La marca es por selector, no por elemento: un mismo nodo puede ser a la vez
     grupo de stagger y bloque de compra. */
  function nuevos(sel, raiz) {
    var lista = (raiz || document).querySelectorAll(sel);
    var out = [];
    for (var i = 0; i < lista.length; i++) {
      var el = lista[i];
      if (!el.__tc) el.__tc = {};
      if (!el.__tc[sel]) { el.__tc[sel] = true; out.push(el); }
    }
    return out;
  }

  /* ------------------------------------------------------------------ */
  /* 1. Reveal on scroll                                                 */
  /* ------------------------------------------------------------------ */
  var observador = null;

  function initReveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('tc-anim');

    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('tc-visible');
            observador.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }

    // stagger: cada hijo con .tc-reveal dentro de [data-tc-stagger] recibe su delay
    nuevos('[data-tc-stagger]').forEach(function (grupo) {
      var paso = parseInt(grupo.getAttribute('data-tc-stagger'), 10) || 0;
      var hijos = grupo.querySelectorAll('.tc-reveal');
      for (var i = 0; i < hijos.length; i++) {
        hijos[i].style.setProperty('--tc-delay', (i * paso) + 'ms');
      }
    });

    nuevos('.tc-reveal, .tc-cortina').forEach(function (el) { observador.observe(el); });
  }

  /* ------------------------------------------------------------------ */
  /* 2. Barra de anuncios                                                */
  /* ------------------------------------------------------------------ */
  function initAnuncio() {
    nuevos('[data-tc-anuncio]').forEach(function (barra) {
      var slides = barra.querySelectorAll('[data-tc-anuncio-slide]');
      if (slides.length < 1) return;
      var i = 0, timer = null;
      var seg = parseFloat(barra.getAttribute('data-tc-anuncio-seg')) || 6;

      function pinta(n) {
        i = (n + slides.length) % slides.length;
        for (var k = 0; k < slides.length; k++) {
          slides[k].classList.toggle('tc-activo', k === i);
          slides[k].setAttribute('aria-hidden', k === i ? 'false' : 'true');
        }
      }
      function arranca() {
        if (slides.length < 2 || timer) return;
        timer = setInterval(function () { pinta(i + 1); }, seg * 1000);
      }
      function para() { if (timer) { clearInterval(timer); timer = null; } }

      pinta(0);
      arranca();
      barra.addEventListener('mouseenter', para);
      barra.addEventListener('mouseleave', arranca);

      var ant = barra.querySelector('[data-tc-anuncio-ant]');
      var sig = barra.querySelector('[data-tc-anuncio-sig]');
      if (ant) ant.addEventListener('click', function () { para(); pinta(i - 1); arranca(); });
      if (sig) sig.addEventListener('click', function () { para(); pinta(i + 1); arranca(); });
    });
  }

  /* ------------------------------------------------------------------ */
  /* 3. Galería arrastrable + miniaturas + dots                          */
  /* ------------------------------------------------------------------ */
  function initGaleria() {
    nuevos('[data-tc-galeria]').forEach(function (gal) {
      var marco = gal.querySelector('.tc-prod__principal');
      var pista = gal.querySelector('[data-tc-galeria-pista]');
      if (!marco || !pista) return;

      var slides = pista.children;
      var minis = gal.querySelectorAll('[data-tc-galeria-mini]');
      var puntos = gal.querySelectorAll('[data-tc-galeria-punto]');
      var total = slides.length;
      var idx = 0;
      var arrastrando = false, x0 = 0, dx = 0, ancho = 0;

      function pinta(n, animar) {
        idx = Math.max(0, Math.min(total - 1, n));
        pista.style.transition = animar === false ? 'none' : '';
        pista.style.transform = 'translate3d(' + (-idx * 100) + '%, 0, 0)';
        for (var i = 0; i < minis.length; i++) {
          minis[i].classList.toggle('tc-activa', i === idx);
        }
        for (var j = 0; j < puntos.length; j++) {
          puntos[j].classList.toggle('tc-activo', j === idx);
          puntos[j].setAttribute('aria-current', j === idx ? 'true' : 'false');
        }
      }

      for (var i = 0; i < minis.length; i++) {
        (function (n) { minis[n].addEventListener('click', function () { pinta(n); }); })(i);
      }
      for (var j = 0; j < puntos.length; j++) {
        (function (n) { puntos[n].addEventListener('click', function () { pinta(n); }); })(j);
      }

      function abajo(e) {
        if (total < 2) return;
        arrastrando = true; dx = 0;
        ancho = marco.offsetWidth || 1;
        x0 = (e.touches ? e.touches[0].clientX : e.clientX);
        marco.classList.add('tc-prod__principal--arrastrando');
      }
      function mueve(e) {
        if (!arrastrando) return;
        var x = (e.touches ? e.touches[0].clientX : e.clientX);
        dx = x - x0;
        var pct = (-idx * 100) + (dx / ancho) * 100;
        pista.style.transform = 'translate3d(' + pct + '%, 0, 0)';
      }
      function arriba() {
        if (!arrastrando) return;
        arrastrando = false;
        marco.classList.remove('tc-prod__principal--arrastrando');
        if (Math.abs(dx) > ancho * 0.16) pinta(idx + (dx < 0 ? 1 : -1));
        else pinta(idx);
      }

      marco.addEventListener('mousedown', abajo);
      window.addEventListener('mousemove', mueve);
      window.addEventListener('mouseup', arriba);
      marco.addEventListener('touchstart', abajo, { passive: true });
      marco.addEventListener('touchmove', mueve, { passive: true });
      marco.addEventListener('touchend', arriba);
      marco.addEventListener('dragstart', function (e) { e.preventDefault(); });

      pinta(0, false);
    });
  }

  /* ------------------------------------------------------------------ */
  /* 4. Selector de packs + modalidad + sticky                           */
  /* ------------------------------------------------------------------ */
  function initCompra() {
    nuevos('[data-tc-variantes]').forEach(function (bloque) {
      var packs = bloque.querySelectorAll('[data-tc-pack]');
      if (!packs.length) return;

      var json = bloque.querySelector('[data-tc-variantes-json]');
      var datos = [];
      try { datos = JSON.parse(json ? json.textContent : '[]') || []; } catch (e) { datos = []; }

      var elPrecio    = bloque.querySelector('[data-tc-precio]');
      var elComparado = bloque.querySelector('[data-tc-comparado]');
      var inpId       = bloque.querySelector('[data-tc-variante-id]');
      var inpArt      = bloque.querySelector('[data-tc-articulos]');
      var inpRegalo   = bloque.querySelector('[data-tc-regalo]');
      var inpPlan     = bloque.querySelector('[data-tc-plan]');
      var boton       = bloque.querySelector('[data-tc-boton]');
      var puntoStock  = bloque.querySelector('[data-tc-stock]');
      var textoStock  = bloque.querySelector('[data-tc-stock-texto]');
      var agotadoTxt  = bloque.getAttribute('data-texto-agotado') || 'Agotado';
      var comprarTxt  = boton ? boton.textContent.trim() : 'Agregar al carrito';

      var modo      = bloque.querySelector('[data-tc-modo]');
      var opUnica   = bloque.querySelector('[data-tc-modo-op="unica"]');
      var opSub     = bloque.querySelector('[data-tc-modo-op="suscripcion"]');
      var pUnica    = bloque.querySelector('[data-tc-modo-precio-unica]');
      var pSub      = bloque.querySelector('[data-tc-modo-precio-sub]');
      var elAhorro  = bloque.querySelector('[data-tc-modo-ahorro]');
      var elDetalle = bloque.querySelector('[data-tc-modo-detalle]');

      var sticky      = document.querySelector('[data-tc-sticky]');
      var sPack       = sticky && sticky.querySelector('[data-tc-sticky-pack]');
      var sPrecio     = sticky && sticky.querySelector('[data-tc-sticky-precio]');
      var sComparado  = sticky && sticky.querySelector('[data-tc-sticky-comparado]');
      var sBoton      = sticky && sticky.querySelector('[data-tc-sticky-boton]');

      var iSel = 0, suscrito = false;
      for (var i = 0; i < packs.length; i++) {
        if (packs[i].classList.contains('tc-activo')) iSel = i;
      }

      function dato(i) { return datos[i] || {}; }

      function pinta() {
        var d = dato(iSel);
        var pack = packs[iSel];
        var plan = (d.planes && d.planes[0]) || null;
        var usaSub = suscrito && plan;

        for (var i = 0; i < packs.length; i++) packs[i].classList.toggle('tc-activo', i === iSel);

        if (elPrecio) elPrecio.textContent = usaSub ? plan.price : (d.price || '');
        if (elComparado) {
          var cmp = usaSub ? (d.price || '') : (d.compare_at_price || '');
          elComparado.textContent = cmp;
          elComparado.hidden = !cmp;
        }

        if (inpId)  inpId.value  = d.id || '';
        if (inpArt) inpArt.value = pack.getAttribute('data-articulos') || '';
        if (inpRegalo) {
          var regalo = pack.getAttribute('data-regalo') || '';
          inpRegalo.value = regalo;
          inpRegalo.disabled = !regalo;
        }
        if (inpPlan) {
          inpPlan.value = usaSub ? plan.id : '';
          inpPlan.disabled = !usaSub;
        }

        // modalidad
        if (modo) {
          if (plan) {
            modo.hidden = false;
            if (pUnica) pUnica.textContent = d.price || '';
            if (pSub) pSub.textContent = plan.price || '';
            if (elAhorro) elAhorro.textContent = plan.ahorro ? (plan.ahorro + '%') : '';
            if (elDetalle) elDetalle.textContent = plan.nombre || '';
            if (opUnica) opUnica.classList.toggle('tc-activo', !suscrito);
            if (opSub) opSub.classList.toggle('tc-activo', !!suscrito);
          } else {
            modo.hidden = true;
            suscrito = false;
          }
        }

        // stock
        var hay = d.available !== false;
        if (puntoStock) puntoStock.classList.toggle('tc-prod__punto--no', !hay);
        if (textoStock) textoStock.textContent = hay ? (textoStock.getAttribute('data-ok') || 'Disponible · Listo para enviar') : agotadoTxt;
        if (boton) {
          boton.disabled = !hay;
          boton.textContent = hay ? comprarTxt : agotadoTxt;
        }
        if (sBoton) {
          sBoton.disabled = !hay;
          sBoton.textContent = hay ? comprarTxt : agotadoTxt;
        }

        // sticky
        if (sPack) sPack.textContent = pack.getAttribute('data-valor') || '';
        if (sPrecio) sPrecio.textContent = usaSub ? plan.price : (d.price || '');
        if (sComparado) {
          var c2 = usaSub ? (d.price || '') : (d.compare_at_price || '');
          sComparado.textContent = c2;
          sComparado.hidden = !c2;
        }
      }

      for (var p = 0; p < packs.length; p++) {
        (function (n) {
          packs[n].addEventListener('click', function () { iSel = n; pinta(); });
        })(p);
      }
      if (opUnica) opUnica.addEventListener('click', function () { suscrito = false; pinta(); });
      if (opSub)   opSub.addEventListener('click',   function () { suscrito = true;  pinta(); });

      /* El alta va por AJAX para abrir el cajón lateral en vez de recargar.
         Con app de bundles (Kaching) funciona igual: la app inyecta SUS
         campos en este mismo formulario (la propiedad __kaching_bundles y
         la cantidad de la oferta) y FormData los recoge tal cual, de modo
         que el descuento y el regalo los sigue aplicando el servidor. */
      pinta();
    });
  }

  /* ------------------------------------------------------------------ *
   * Alta en el carrito por AJAX: abre el cajon lateral del tema en vez
   * de recargar la pagina. Si el tema no expone <cart-drawer>, devuelve
   * false y el formulario se envia de forma nativa.
   * ------------------------------------------------------------------ */
  function alCarrito(form, boton) {
    var cajon = document.querySelector('cart-drawer');
    if (!cajon || typeof cajon.renderContents !== 'function') return false;
    if (typeof window.FormData === 'undefined' || typeof window.fetch === 'undefined') return false;

    var datos = new FormData(form);
    var ids = [];
    if (typeof cajon.getSectionsToRender === 'function') {
      cajon.getSectionsToRender().forEach(function (s) { ids.push(s.id); });
    }
    if (ids.length) {
      datos.append('sections', ids.join(','));
      datos.append('sections_url', window.location.pathname);
    }

    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var original = boton ? boton.innerHTML : '';
    function restaura() {
      if (!boton) return;
      boton.removeAttribute('aria-busy');
      boton.disabled = false;
    }
    if (boton) { boton.setAttribute('aria-busy', 'true'); boton.disabled = true; }

    fetch(raiz + 'cart/add', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: datos
    })
      .then(function (r) { return r.json(); })
      .then(function (estado) {
        restaura();
        if (estado && estado.status) {
          if (boton) {
            boton.innerHTML = estado.description || estado.message || 'No disponible';
            setTimeout(function () { boton.innerHTML = original; }, 3000);
          }
          return;
        }
        if (cajon.classList) cajon.classList.remove('is-empty');
        cajon.renderContents(estado);
      })
      .catch(function () {
        restaura();
        form.submit();
      });

    return true;
  }

  /* ------------------------------------------------------------------ *
   * Alta en el carrito por AJAX. Va en su propia pasada A PROPOSITO: la
   * de packs corta antes con `if (!packs.length) return`, y cuando la
   * oferta la lleva una app de bundles no hay packs propios, asi que el
   * formulario se quedaba sin enganchar y el navegador saltaba a /cart.
   * ------------------------------------------------------------------ */
  function initCarritoAjax() {
    nuevos('[data-tc-variantes] form').forEach(function (form) {
      var boton = form.querySelector('[data-tc-boton]');
      form.addEventListener('submit', function (ev) {
        if (alCarrito(form, boton)) ev.preventDefault();
      });

      /* El boton de la barra fija vive en otra seccion (tc-sticky), fuera
         del formulario y con type="button": sin esto no hace nada. */
      var sBoton = document.querySelector('[data-tc-sticky-boton]');
      if (sBoton && !sBoton.__tcCart) {
        sBoton.__tcCart = true;
        sBoton.addEventListener('click', function () {
          if (alCarrito(form, sBoton)) return;
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
        });
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* 5. Acordeones                                                       */
  /* ------------------------------------------------------------------ */
  function initAcordeon() {
    nuevos('.tc-faq__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.tc-faq__item');
        if (!item) return;
        var abierto = item.classList.toggle('tc-abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* 6. Comparador antes / después                                       */
  /* ------------------------------------------------------------------ */
  function initComparador() {
    nuevos('[data-tc-comparador]').forEach(function (marco) {
      var rango = marco.querySelector('[data-tc-comp-rango]');
      var capa  = marco.querySelector('[data-tc-comp-capa]');
      if (!capa) return;

      function set(pct) {
        pct = Math.max(0, Math.min(100, pct));
        marco.style.setProperty('--tc-comp-x', pct + '%');
        if (rango) rango.value = pct;
      }
      function desdeEvento(e) {
        var r = marco.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
        set((x / (r.width || 1)) * 100);
      }

      var activo = false;
      function abajo(e) { activo = true; marco.classList.add('tc-comp--arrastrando'); desdeEvento(e); }
      function mueve(e) { if (activo) desdeEvento(e); }
      function arriba() { activo = false; marco.classList.remove('tc-comp--arrastrando'); }

      marco.addEventListener('mousedown', abajo);
      window.addEventListener('mousemove', mueve);
      window.addEventListener('mouseup', arriba);
      marco.addEventListener('touchstart', abajo, { passive: true });
      marco.addEventListener('touchmove', mueve, { passive: true });
      marco.addEventListener('touchend', arriba);

      if (rango) {
        rango.style.pointerEvents = 'none';
        rango.addEventListener('input', function () { set(parseFloat(rango.value)); });
        rango.addEventListener('keydown', function (e) {
          var paso = e.shiftKey ? 10 : 2;
          if (e.key === 'ArrowLeft')  { set(parseFloat(rango.value) - paso); e.preventDefault(); }
          if (e.key === 'ArrowRight') { set(parseFloat(rango.value) + paso); e.preventDefault(); }
        });
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* 7. Carrusel de reseñas                                              */
  /* ------------------------------------------------------------------ */
  function initCarrusel() {
    nuevos('[data-tc-carrusel]').forEach(function (wrap) {
      var pista = wrap.querySelector('[data-tc-carrusel-pista]');
      if (!pista) return;
      var ant = wrap.querySelector('[data-tc-carrusel-ant]');
      var sig = wrap.querySelector('[data-tc-carrusel-sig]');
      var puntos = wrap.querySelectorAll('[data-tc-carrusel-punto]');
      var cards = pista.children;

      function salto() {
        var c = cards[0];
        if (!c) return pista.clientWidth;
        var gap = parseFloat(getComputedStyle(pista).columnGap || getComputedStyle(pista).gap || 0) || 0;
        return c.getBoundingClientRect().width + gap;
      }
      function indice() {
        var s = salto() || 1;
        return Math.round(pista.scrollLeft / s);
      }
      function sincroniza() {
        var i = indice();
        for (var k = 0; k < puntos.length; k++) puntos[k].classList.toggle('tc-activo', k === i);
        if (ant) ant.disabled = pista.scrollLeft <= 2;
        if (sig) sig.disabled = pista.scrollLeft >= pista.scrollWidth - pista.clientWidth - 2;
      }

      if (ant) ant.addEventListener('click', function () { pista.scrollBy({ left: -salto(), behavior: 'smooth' }); });
      if (sig) sig.addEventListener('click', function () { pista.scrollBy({ left:  salto(), behavior: 'smooth' }); });
      for (var k = 0; k < puntos.length; k++) {
        (function (n) {
          puntos[n].addEventListener('click', function () { pista.scrollTo({ left: n * salto(), behavior: 'smooth' }); });
        })(k);
      }
      pista.addEventListener('scroll', function () {
        window.clearTimeout(pista.__tcT);
        pista.__tcT = window.setTimeout(sincroniza, 90);
      });
      window.addEventListener('resize', sincroniza);
      sincroniza();
    });
  }

  /* ------------------------------------------------------------------ */
  /* 8. Barra sticky: aparece al pasar el formulario, se esconde con el pie */
  /* ------------------------------------------------------------------ */
  function initSticky() {
    nuevos('[data-tc-sticky]').forEach(function (barra) {
      var ancla = document.querySelector('[data-tc-sticky-ancla]') || document.querySelector('.tc-prod__form');
      if (!ancla) return;

      var pieVisible = false;
      var pie = document.querySelector('footer, .tc-foot, #shopify-section-footer, [id*="__footer"]');

      function evalua() {
        var r = ancla.getBoundingClientRect();
        var pasado = r.bottom < 0;
        barra.classList.toggle('tc-sticky--on', pasado && !pieVisible);
      }

      if ('IntersectionObserver' in window && pie) {
        new IntersectionObserver(function (es) {
          pieVisible = es[0].isIntersecting;
          evalua();
        }, { threshold: 0 }).observe(pie);
      }

      window.addEventListener('scroll', evalua, { passive: true });
      window.addEventListener('resize', evalua);
      evalua();
    });
  }

  /* ------------------------------------------------------------------ */
  /* 9. Contadores de las cifras                                         */
  /* ------------------------------------------------------------------ */
  function initContadores() {
    if (reduce || !('IntersectionObserver' in window)) return;
    nuevos('[data-tc-contador]').forEach(function (el) {
      var destino = (el.getAttribute('data-tc-contador') || '').trim();
      var n = parseInt(destino.replace(/[^\d]/g, ''), 10);
      if (!isFinite(n) || /[-–/]/.test(destino)) return;   // rangos tipo "3-6" no se animan

      new IntersectionObserver(function (es, obs) {
        if (!es[0].isIntersecting) return;
        obs.disconnect();
        var t0 = null, dur = 1100;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / dur);
          var e = 1 - Math.pow(1 - p, 3);
          el.textContent = String(Math.round(n * e));
          if (p < 1) requestAnimationFrame(paso);
          else el.textContent = destino;
        }
        el.textContent = '0';
        requestAnimationFrame(paso);
      }, { threshold: 0.4 }).observe(el);
    });
  }

  /* ------------------------------------------------------------------ */
  function initTodo() {
    initReveal();
    initAnuncio();
    initGaleria();
    initCompra();
    initCarritoAjax();
    initAcordeon();
    initComparador();
    initCarrusel();
    initSticky();
    initContadores();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTodo);
  } else {
    initTodo();
  }

  // el personalizador de Shopify recarga secciones sueltas
  document.addEventListener('shopify:section:load', initTodo);
  document.addEventListener('shopify:section:select', initTodo);
})();


/* ------------------------------------------------------------------ *
 * Precio de cabecera sincronizado con Kaching.
 * Con la oferta en la app (data-tc-oferta-app="1") el precio de arriba
 * lo pinta Liquid una sola vez; aquí se copia el del tramo que esté
 * seleccionado en Kaching cuando cambia. Solo se observa el bloque de
 * Kaching y solo se escribe si el texto es distinto (sin bucles).
 * ------------------------------------------------------------------ */
(function tcSyncKaching () {
  function limpia (t) { return (t || '').replace(/\s+/g, ' ').replace('$ ', '$').trim(); }
  function pon (el, t) { if (el && t && el.textContent !== t) el.textContent = t; }
  function engancha (bloque) {
    var elPrecio = bloque.querySelector('[data-tc-precio]');
    var elComparado = bloque.querySelector('[data-tc-comparado]');
    var app = bloque.querySelector('kaching-bundles-block');
    if (!elPrecio || !app || app.contains(elPrecio)) return;
    var pendiente = false;
    function pinta () {
      pendiente = false;
      var sel = app.querySelector('.kaching-bundles__bar--selected');
      if (!sel) return;
      var p = sel.querySelector('.kaching-bundles__bar-price');
      var c = sel.querySelector('.kaching-bundles__bar-full-price');
      pon(elPrecio, p && limpia(p.textContent));
      if (elComparado) {
        var tc = c && limpia(c.textContent);
        if (tc) { pon(elComparado, tc); if (elComparado.hidden) elComparado.hidden = false; }
        else if (!elComparado.hidden) elComparado.hidden = true;
      }
    }
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(pinta);
    }).observe(app, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    pinta();
  }
  function arranca () {
    document.querySelectorAll('[data-tc-oferta-app="1"]').forEach(engancha);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca);
  else arranca();
})();
